import axios from "axios";
import { env_camera_url } from "serverEnv";

export const getFacilitiesMeApi = (token: string) => {
  return axios.get(`${env_camera_url}/me/facilities`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};
